import { clip, storage } from "@platform/index"
export function getUrl() {
  return window?.location?.href || ""
}
/**
 * 获取cookie
 * @param name
 */
export function getCookie(name?: string) {
  const { cookie } = document
  if (!name?.length) return cookie
  if (!cookie?.length) return ""
  const cookies = cookie.split(";")
  for (let item of cookies) {
    const [key, value] = item.split("=")
    if (key.trim() === name) return value
  }
  return ""
}
export function getLocalStroage(name?: string) {
  if (!name?.length) return window?.localStorage.valueOf()
  return storage.get(name)
}

export async function getClip() {
  return await clip.get()
}
